import champions from "../data/champions.json";
import { darkTeams, noShadowTeams } from "../hooks/vars";
import teamsBasic from "../data/teamsBasic2025.json";
import "../css/champs.css";

export function Champions() {
  return (
    <div className="defaultModal champModule">
      <h3>SUPER BOWL CHAMPIONS</h3>
      <ChampionsList />
    </div>
  );
}

function ChampionsList() {
  const champList = champions
    .sort((a, b) => b.year - a.year)
    .map((data, i) => {
      let afc = data.afc;
      let afcName = data.afc_champion;
      let nfc = data.nfc;
      let nfcName = data.nfc_champion;
      let sb = data.sb;
      // let sbName = data.super_bowl_champion;
      let sbRoman = data.super_bowl;
      let sbLoc = data.super_bowl_location;
      let sbStad = data.super_bowl_stadium;
      let afcWin = false;
      let nfcWin = false;

      //console.log(theTeam);
      if (afc === "OAK") {
        afc = "LV";
      }
      if (afc === sb) afcWin = true;
      if (nfc === sb) nfcWin = true;
      return (
        <div className="champRow" key={i}>
          <div className="sbInfo">
            <div className="year">{data.year}</div>
            <div className="sbX">Super Bowl {sbRoman}</div>
            <div className="sbLoc">
              {sbStad} | {sbLoc}
            </div>
          </div>
          <TeamCard t={afc} n={afcName} w={afcWin} />
          <TeamCard t={nfc} n={nfcName} w={nfcWin} />
        </div>
      );
    });
  return champList;
}

function TeamCard(props) {
  //t=team key n=full name
  const teamData = teamsBasic.find((data) => data.Key === props.t);
  const darkTeam = darkTeams.includes(teamData.Key);

  return (
    <div
      className=" standingsRow champCard"
      key={props.k}
      style={{
        background:
          "linear-gradient(15deg,#000 -100%, #" +
          teamData.PrimaryColor +
          " 40%)",
        color:
          "#" + (!darkTeam ? teamData.SecondaryColor : teamData.TertiaryColor),
        textShadow: noShadowTeams.includes(teamData.Key)
          ? ".5px .5px 0px #ffffff36"
          : "1px 1px 0 #00000085",
        border: props.w ? "solid 4px #fff" : "none",
        // borderRadius: props.w ? "12px" : "0",
        zIndex: props.w ? "101" : "0",
        opacity: props.w ? 1 : .65,
        boxShadow: props.w ? "0 0 10px #fff" : "",
        // transform: props.w ? "scale(1.05)" : ""
      }}
    >
      <div
        className="teamCardLogo"
        style={{
          backgroundImage: "url(" + teamData.WikipediaLogoURL + ")",
        }}
      ></div>
      <div className="teamCardName">
        {props.n} {darkTeam}
      </div>
      <div className={props.w ? "lombardi" : "loser"}></div>
    </div>
  );
}
